import React, { useEffect, useState } from "react";
import { LayoutDashboard, FileText, FolderKanban, CalendarRange, Users, UserCog, MessageSquare, PhoneCall, Briefcase, Globe, Palette, ScrollText, Contact2, Files, Images, Image as ImageIcon, DatabaseBackup, Plug, Trash2 } from "lucide-react";
import api from "@/lib/api";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import PortalSwitch from "@/components/dashboard/PortalSwitch";
import { useAuth } from "@/context/AuthContext";

export default function AdminLayout() {
  const { hasPerm } = useAuth();
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data || {})).catch(() => {}); }, []);
  const nav = [
    { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
    { to: "/admin/demandes", label: "Demandes & dispatch", icon: FileText, badge: stats.awaiting_assignment },
    { to: "/admin/projets", label: "Projets", icon: FolderKanban },
    { to: "/admin/planning", label: "Planning équipe", icon: CalendarRange },
    { to: "/admin/prospects", label: "Prospects", icon: Contact2, badge: stats.new_leads },
    { to: "/admin/clients", label: "Clients", icon: Users },
    { to: "/admin/equipe", label: "Équipe", icon: UserCog },
    { to: "/admin/messages", label: "Messagerie", icon: MessageSquare, badge: stats.unread_messages },
    { to: "/admin/rappels-urgents", label: "Rappels urgents", icon: PhoneCall, badge: stats.urgent_callbacks },
    { to: "/admin/services", label: "Services", icon: Briefcase },
    { to: "/admin/site", label: "Site internet", icon: Globe },
    { to: "/admin/site/pages", label: "Pages", icon: Files },
    { to: "/admin/site/medias", label: "Médias", icon: Images },
    { to: "/admin/design", label: "Design & thème", icon: Palette },
    { to: "/admin/design/logo", label: "Logo", icon: ImageIcon },
    { to: "/admin/sauvegardes", label: "Sauvegardes", icon: DatabaseBackup },
    { to: "/admin/corbeille", label: "Corbeille", icon: Trash2 },
    ...(hasPerm("manage_system_settings") ? [{ to: "/admin/integrations", label: "Intégrations", icon: Plug }] : []),
    { to: "/admin/audit", label: "Journal d'audit", icon: ScrollText },
  ];
  return <DashboardLayout nav={nav} portalSwitch={<PortalSwitch />} />;
}
